import React, { useEffect, useRef, useState } from "react";
import "./exam.css";
import Navbar from "../../components/navbar/Navbar";
import upscimg from "../../images/upsc.png";
import Rightside from "../../components/rightside/Rightside";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import logo from "../../images/white-logo.png";
import Form from "react-bootstrap/Form";
import { Link, NavLink, useParams } from "react-router-dom";
import { CgSearch } from "react-icons/cg";
import Guide from "../../components/guide/Guide";
import { BiSearch } from "react-icons/bi";
import { useContext } from "react";
import SearchContext from "../../context/SearchContext";
import { baseUrl } from "../../context/BaseUrl";
import parse from "html-react-parser";
import MobNav from "../../components/Mobnav/MobNav";

const Exam = () => {
  const { search, setSearch } = useContext(SearchContext);
  const { id, name } = useParams();
  const [data, setData] = useState(false);

  const syllabusToRef = useRef();
  const aboutToRef = useRef();

  const jobToRef = useRef();

  const galleryToRef = useRef();

  const blogToRef = useRef();

  const courseToRef = useRef();

  const fetchData = async () => {
    const response = await fetch(
      `${baseUrl}/user/category/getcategory_details/${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();
    setData(() => result);
  };

  useEffect(() => {
    setSearch(() => ({ ...search, category: id }));
    fetchData();
  }, [id]);

  return (
    data && (
      <>
        <div className="upsc-background upsc-top-card d-flex d-md-none">
          <div className="home-cell container pt-0">
            <MobNav dnone="d-none" />
            <div className="home-cell bg-green d-block d-md-flex">
            <div className="container upsc-top-card">
              <div className="row">
                <div className="col-md-3 col-3">
                  <div className="upsc-img">
                    <img src={data.icon ? data.icon : upscimg} alt="upsc" className="img-fluid" />
                  </div>
                </div>
                <div className="col-md-9 col-9 d-flex d-md-block justify-content-center flex-column">
                  <div className="upsc text">
                    <h3>{data.title}</h3>
                  </div>
                </div>
                    <p className="for mb-0 pt-1 mt-3  text-center">{parse(data.description)}</p>
              </div>
            </div>
          </div>
            <div className="location-srch location-srch-mobile col-12 d-md-flex bg-green   d-flex align-item-center pt-4 pb-2 ">
              <div className="container">
                <Form.Select
                  aria-label="Default select example"
                  onChange={(e) =>
                    setSearch({ ...search, location: [e.target.value] })
                  }
                >
                  <option value={""}> Select</option>
                  <option value="delhi">Delhi</option>
                  <option value="patna">Patna</option>
                  <option value="kota">Kota</option>
                  <option value="lucknow">Lucknow</option>
                  <option value="hyderabad">Hyderabad</option>
                  <option value="mumbai">Mumbai</option>
                </Form.Select>
                <div className="search bodr mb-4">
                  <input
                    type="text"
                    value={`${search.key}`}
                    placeholder={`${name} Institutes`}
                    onInput={(e) =>
                      setSearch({ ...search, name: e.target.value })
                    }
                  />
                  <span>
                    <Link
                      to={`/listing/${data.category_name.replace(" ", "-")}/${
                        data._id
                      }`}
                    >
                      <CgSearch />
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="upsc-background home-background">
          <Navbar logoimg={logo} home={"homepage"} />
          <div className="home-cell">
            <div className="container upsc-top-card">
              <div className="row">
                <div className="col-md-3 col-3">
                  <div className="upsc-img">
                    <img src={data.icon ? data.icon : upscimg} alt="upsc" />
                  </div>
                </div>
                <div className="col-md-9 col-9 d-flex d-md-block justify-content-center flex-column">
                  <div className="upsc text">
                    <h3>{data.title}</h3>
                    <p className="forpc">{parse(data.description)}</p>
                  </div>
                </div>
                <div className="location-srch pt-2 mb-0 pb-0 col-12 d-md-none d-flex  align-item-center">
                  <p className="forpc">{parse(data.about)}</p>
                </div>
                <div className="location-srch col-12 d-md-flex d-none  align-item-center">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) =>
                      setSearch({ ...search, location: [e.target.value] })
                    }
                  >
                    <option value={""}> Select</option>
                    <option value="delhi">Delhi</option>
                    <option value="patna">Patna</option>
                    <option value="kota">Kota</option>
                    <option value="lucknow">Lucknow</option>
                    <option value="hyderabad">Hyderabad</option>
                    <option value="mumbai">Mumbai</option>
                  </Form.Select>
                  <div className="search">
                    <input
                      type="text"
                      value={`${search.key}`}
                      placeholder={`${name} Institutes`}
                      onInput={(e) =>
                        setSearch({ ...search, name: e.target.value })
                      }
                    />
                    <span>
                      <Link
                        to={`/listing/${data.category_name.replace(" ", "-")}/${
                          data._id
                        }`}
                      >
                        <CgSearch />
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* upsc-background end */}
        </div>
        

        {/* <div className="upsc-search">
        <input type="text" placeholder="Obepedia" />
         <span><BiSearch />
        </span> 
      </div> */}
        {/* <Guide margin={"mx-10"} /> */}

        <div className="upsc2 container-fluid">
          <div className="tab-view px-10">
            <ul className="nav bg-white">
              <li className="mt-2">
                <Link
                  to=""
                  className="active"
                  onClick={() => syllabusToRef.current.scrollIntoView()}
                >
                  Overview
                </Link>
              </li>
              <li className="mt-2">
                <Link to="" onClick={() => aboutToRef.current.scrollIntoView()}>
                  Description
                </Link>
              </li>
              <li className="mt-2">
                <Link
                  to=""
                  onClick={() => courseToRef.current.scrollIntoView()}
                >
                  Preperation
                </Link>
              </li>
              <li className="mt-2">
                <Link to="" onClick={() => blogToRef.current.scrollIntoView()}>
                  Updates
                </Link>
              </li>
              <li className="mt-2">
                <Link to="" onClick={() => jobToRef.current.scrollIntoView()}>
                  Elegibility
                </Link>
              </li>
            </ul>
            {/* tab-view end */}
            {/*  <div className="tab-content">
                    <div className="about" ref={aboutToRef}>
                    About
                    </div>
                    <div className="course " ref={courseToRef}>
                      <h4>Courses</h4>
                    </div>

                    <div className="faculty" ref={facultToRef}>
                      <h4>Faculty</h4>
                    </div>
                    <div className="gallery" ref={galleryToRef}>
                      <h4>Gallery</h4>
                    </div>
                    <div className="job-vacancy" ref={jobToRef}>
                      <h4>Job Vacancy</h4>
                    </div>
                    
                  </div> tab-content end*/}
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                <div className="upscleft">
                <h3 ref={aboutToRef}>Quick Links </h3>
                  <div className="highlights p-2" ref={syllabusToRef}>
                    {parse(data.syllabus)}
                  </div>
                  <h3 ref={aboutToRef}>Description </h3>
                  <p className="parah">{parse(data.about)}</p>
                  <h3 ref={courseToRef}>Exam Preperation</h3>
                  <p className="parah">{parse(data.exam_prep)} </p>
                  <h3 className="pb-4" ref={blogToRef}>
                    Latest update
                  </h3>
                  <p className="parah">{parse(data.latest_update)}</p>
                  <h3 ref={jobToRef} className="pb-4">
                    Elegibility Criteria
                  </h3>
                  <p className="parah">{parse(data.eligibility)}</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                <div className="rigthside">
                  <Rightside />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <FooterMob />
      </>
    )
  );
};

export default Exam;

// import React, { useEffect, useRef, useState } from "react";
// import "./exam.css";
// import Navbar from "../../components/navbar/Navbar";
// import upscimg from "../../images/upsc.png";
// import Rightside from "../../components/rightside/Rightside";
// import Footer from "../../components/footer/Footer";
// import FooterMob from "../../components/footer/FooterMob";
// import logo from "../../images/white-logo.png";
// import Form from "react-bootstrap/Form";
// import { Link, NavLink, useParams } from "react-router-dom";
// import { CgSearch } from "react-icons/cg";
// import Guide from "../../components/guide/Guide";
// import { BiSearch } from "react-icons/bi";
// import { useContext } from "react";
// import SearchContext from "../../context/SearchContext";
// import { baseUrl } from "../../context/BaseUrl";
// import parse from "html-react-parser";

// const Exam = () => {
//   const { search, setSearch } = useContext(SearchContext);
//   const { id, name } = useParams();
//   const [data, setData] = useState(false);

//   const syllabusToRef = useRef();
//   const aboutToRef = useRef();

//   const jobToRef = useRef();

//   const galleryToRef = useRef();

//   const blogToRef = useRef();

//   const courseToRef = useRef();

//   const fetchData = async () => {
//     const response = await fetch(
//       `${baseUrl}/user/category/getcategory_details/${id}`,
//       {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     const result = await response.json();
//     setData(() => result);
//   };

//   useEffect(() => {
//     setSearch(() => ({ ...search, category: id }));
//     fetchData();
//   }, [id]);

//   return (
//     data && (
//       <>
//         <div className="upsc-background home-background">
//           <Navbar logoimg={logo} home={"homepage"} />
//           <div className="home-cell">
//             <div className="container upsc-top-card">
//               <div className="row">
//                 <div className="col-md-3 col-3">
//                   <div className="upsc-img">
//                     <img src={data.icon ? data.icon : upscimg} alt="upsc" />
//                   </div>
//                 </div>
//                 <div className="col-md-9 col-9 d-flex d-md-block justify-content-center flex-column">
//                   <div className="upsc text">
//                     <h3>{data.title}</h3>
//                     <p className="forpc">{parse(data.about)}</p>
//                   </div>
//                 </div>
//                 <div className="location-srch pt-2 mb-0 pb-0 col-12 d-md-none d-flex  align-item-center">
//                   <p className="forpc">{data.about}</p>
//                 </div>
//                 <div className="location-srch col-12 d-md-flex d-none  align-item-center">
//                   <Form.Select
//                     aria-label="Default select example"
//                     onChange={(e) =>
//                       setSearch({ ...search, location: [e.target.value] })
//                     }
//                   >
//                     <option value={""}> Select</option>
//                     <option value="delhi">Delhi</option>
//                     <option value="patna">Patna</option>
//                     <option value="kota">Kota</option>
//                     <option value="lucknow">Lucknow</option>
//                     <option value="hyderabad">Hyderabad</option>
//                     <option value="mumbai">Mumbai</option>
//                   </Form.Select>
//                   <div className="search">
//                     <input
//                       type="text"
//                       value={`${search.name}`}
//                       placeholder={`${name} Institutes`}
//                       onInput={(e) =>
//                         setSearch({ ...search, name: e.target.value })
//                       }
//                     />
//                     <span>
//                       <Link
//                         to={`/listing/${data.category_name.replace(" ", "-")}/${
//                           data._id
//                         }`}
//                       >
//                         <CgSearch />
//                       </Link>
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* upsc-background end */}
//         </div>

//         {/* <div className="upsc-search">
//         <input type="text" placeholder="Obepedia" />
//          <span><BiSearch />
//         </span>
//       </div> */}
//         {/* <Guide margin={"mx-10"} /> */}

//         <div className="upsc2 container-fluid">
//           <div className="tab-view px-10">
//             <ul className="nav bg-white">
//               <li>
//                 <Link
//                   to=""
//                   className="active"
//                   onClick={() => syllabusToRef.current.scrollIntoView()}
//                 >
//                   About
//                 </Link>
//               </li>
//               <li>
//                 <Link to="" onClick={() => aboutToRef.current.scrollIntoView()}>
//                   Description
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to=""
//                   onClick={() => courseToRef.current.scrollIntoView()}
//                 >
//                   Preperation
//                 </Link>
//               </li>
//               <li>
//                 <Link to="" onClick={() => blogToRef.current.scrollIntoView()}>
//                   Updates
//                 </Link>
//               </li>
//               <li>
//                 <Link to="" onClick={() => jobToRef.current.scrollIntoView()}>
//                   Elegibility
//                 </Link>
//               </li>
//             </ul>
//             {/* tab-view end */}
//             {/*  <div className="tab-content">
//                     <div className="about" ref={aboutToRef}>
//                     About
//                     </div>
//                     <div className="course " ref={courseToRef}>
//                       <h4>Courses</h4>
//                     </div>

//                     <div className="faculty" ref={facultToRef}>
//                       <h4>Faculty</h4>
//                     </div>
//                     <div className="gallery" ref={galleryToRef}>
//                       <h4>Gallery</h4>
//                     </div>
//                     <div className="job-vacancy" ref={jobToRef}>
//                       <h4>Job Vacancy</h4>
//                     </div>

//                   </div> tab-content end*/}
//             <div className="row">
//               <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
//                 <div className="upscleft">
//                   <div className="highlights" ref={syllabusToRef}>
//                     {data.syllabus}
//                   </div>
//                   <h3 ref={aboutToRef}>Description </h3>
//                   <p className="parah">{data.description}</p>
//                   <h3 ref={courseToRef}>Exam Preperation</h3>
//                   <p className="parah">{data.exam_prep} </p>
//                   <h3 className="pb-4" ref={blogToRef}>
//                     Latest update
//                   </h3>
//                   <p className="parah">{data.latest_update}</p>
//                   <h3 ref={jobToRef} className="pb-4">
//                     Elegibility Criteria
//                   </h3>
//                   <p className="parah">{data.eligibility}</p>
//                 </div>
//               </div>
//               <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
//                 <div className="rigthside">
//                   <Rightside />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <Footer />
//         <FooterMob />
//       </>
//     )
//   );
// };

// export default Exam;
